var render = function render(){var _vm=this,_c=_vm._self._c;return _c('messages',{attrs:{"title":_vm.$t('latest news'),"title-icon":"mdi-email-outline","page-size":"5","only-scope":['news'],"days-ago":"180","ignore-staff":"","no-server-pagination":"","no-scope":"","no-search":"","no-filter":"","no-reload":"","no-dedicated":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }